<table datatable [dtOptions]="dtOptions" class="table-striped table-sm row-border hover">
  <thead>
    <tr>
      <th>S.No</th>
      <th>{{listLang.section}}</th>
      <th>{{listLang.title}}</th>
      <th>{{listLang.actions}}</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let form of listResp let i = index">
      <td>{{i+1}}</td>
      <td>{{form.section_title}}</td>
      <td>{{form.title}}</td>
      <td>
        <div class="btn-group dropup">
          <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
            aria-expanded="false">
            <i class="fa fa-tasks"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
            <li>
              <a class="view_action" (click)="FormMangClick($event)" [attr.data-section]="form.section_id"
              [attr.data-title]="form.title_id" data-action="view">
                <i class="glyphicon glyphicon-eye-open"></i> {{listLang.view}}
              </a>
            </li>
            <li>
              <a class="edit_action" (click)="FormMangClick($event)" [attr.data-section]="form.section_id"
                [attr.data-title]="form.title_id" data-action="edit">
                <i class="fa fa-edit"></i> {{listLang.modify}}
              </a>
            </li>
            <li>
              <a class="reload_action" (click)="FormMangClick($event)" [attr.data-section]="form.section_id"
              [attr.data-title]="form.title_id" data-action="reload">
                <i class="glyphicon glyphicon-repeat"></i> {{listLang.reload}}
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<ng-template #FormMangModal>

  <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
    <div *ngFor="let validation of msg">
      <div class="error-message"
        *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
        {{validation.message}}
      </div>
    </div>
  </ng-template>

  <form [formGroup]="FormMangForm" class="form-validation" (ngSubmit)="updateForm()">

    <div class="modal-header">
      <h4 class="modal-title pull-left">{{editLang.edit_doc}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body section-spaces">

      <div class="row">
        <div class="col-md-9">

          <div class="row">
            <div class="form-group col-sm-12">
              <label>{{editLang.section}}</label>
              <input type="text" class="form-control" formControlName="section_title">
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-12">
              <label>{{editLang.title}}</label>
              <input type="text" class="form-control" formControlName="title">
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-12">
              <label>{{editLang.orient}}</label>
              <div>
                <label class="checkbox-inline checkbox-custom-alt">
                  <input type="radio" formControlName="orientation" value="1"><i></i> {{editLang.horizontal}}
                </label>
                <label class="checkbox-inline checkbox-custom-alt">
                  <input type="radio" formControlName="orientation" value="0"><i></i> {{editLang.vertical}}
                </label>
              </div>
            </div>
          </div>

          <div class="row background-image">
            <div class="form-group col-sm-12">
              <label>{{editLang.back_image}}</label>
              <input type="file" class="filestyle" data-buttonText="Choose file" (change)="BackgroundImageChange($event)" formControlName="background" [ngClass]="formErrorClass(FormMangForm.controls.background, FormMangFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:FormMangFormErrorMsg.background, value:FormMangForm.controls.background, submitted:FormMangFormSubmitted }">
              </ng-template>

              <input type="hidden" formControlName="background_exists">
              
              <div class="row text-center m-5 list" *ngIf="backgroundDiv">
                <!-- <a
                (click)="imagePreview(FormMangForm.controls['background_exists_full'].value)"
                >{{FormMangForm.controls['background_exists'].value}}</a> -->

                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/form_management/{{FormMangForm.controls['background_exists'].value}}" target="_blank">{{FormMangForm.controls['background_exists'].value}}</a>


                <button class="btn btn-primary pull-right" type="button" (click)="BackgroundImageRemove()">
                  <i class="fa fa-trash-o"></i>
                </button>
              
              </div>


            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-12">
              <label>{{editLang.template}}</label>
              <ckeditor 
              #editor
              formControlName="html_body"
              [config]="ckeditor_config"
              (focus)="ckeditorOnFocus()"
              (blur)="ckeditorOnBlur()"
              [ngClass]="formErrorClass(FormMangForm.controls.html_body, FormMangFormSubmitted)"
              ></ckeditor>

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:FormMangFormErrorMsg.html_body, value:FormMangForm.controls.html_body, submitted:FormMangFormSubmitted }">
              </ng-template>

            </div>
          </div>

          

        </div>


        <div class="col-md-3">
          <div class="adjust-text">
            <h3>{{editLang.default_var}}</h3>
            <div class="adjust-scroll">
              <ul>
                <li *ngFor="let variable of editResp.html_variables | keyvalue" (click)=ckeditorInsert(variable.key);>
                  <span class="insert_variable">{{variable.value}}</span>
                </li>
              </ul>
              <input type="hidden" class="focus_element">
            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-success">{{editLang.submit}}</button>
        <button type="button" class="btn btn-warning" (click)="modalRef.hide()">{{editLang.close}}</button>
      </div>

    </div>

  </form>
</ng-template>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>

<ng-template #FormMangViewModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">PDF Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
      <pdf-viewer [src]="pdfSrc" 
              [render-text]="true"
              style="display: block;"
      ></pdf-viewer>
  </div>

</ng-template>

